// extracted by mini-css-extract-plugin
export default {"wrapper":"HC-z","viewport":"IC-z","container":"JC-z","slide":"KC-z"};